import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconChartScatterplot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 2.25C3.41421 2.25 3.75 2.58579 3.75 3V20.25H21C21.4142 20.25 21.75 20.5858 21.75 21C21.75 21.4142 21.4142 21.75 21 21.75H3C2.58579 21.75 2.25 21.4142 2.25 21V3C2.25 2.58579 2.58579 2.25 3 2.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.25 16.5C5.25 15.2574 6.25736 14.25 7.5 14.25C8.74264 14.25 9.75 15.2574 9.75 16.5C9.75 17.7426 8.74264 18.75 7.5 18.75C6.25736 18.75 5.25 17.7426 5.25 16.5ZM7.5 15.75C7.08579 15.75 6.75 16.0858 6.75 16.5C6.75 16.9142 7.08579 17.25 7.5 17.25C7.91421 17.25 8.25 16.9142 8.25 16.5C8.25 16.0858 7.91421 15.75 7.5 15.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 8.25C6.25736 8.25 5.25 9.25736 5.25 10.5C5.25 11.7426 6.25736 12.75 7.5 12.75C8.74264 12.75 9.75 11.7426 9.75 10.5C9.75 9.25736 8.74264 8.25 7.5 8.25ZM6.75 10.5C6.75 10.0858 7.08579 9.75 7.5 9.75C7.91421 9.75 8.25 10.0858 8.25 10.5C8.25 10.9142 7.91421 11.25 7.5 11.25C7.08579 11.25 6.75 10.9142 6.75 10.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.25 13.5C11.25 12.2574 12.2574 11.25 13.5 11.25C14.7426 11.25 15.75 12.2574 15.75 13.5C15.75 14.7426 14.7426 15.75 13.5 15.75C12.2574 15.75 11.25 14.7426 11.25 13.5ZM13.5 12.75C13.0858 12.75 12.75 13.0858 12.75 13.5C12.75 13.9142 13.0858 14.25 13.5 14.25C13.9142 14.25 14.25 13.9142 14.25 13.5C14.25 13.0858 13.9142 12.75 13.5 12.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.5 4.25C11.2574 4.25 10.25 5.25736 10.25 6.5C10.25 7.74264 11.2574 8.75 12.5 8.75C13.7426 8.75 14.75 7.74264 14.75 6.5C14.75 5.25736 13.7426 4.25 12.5 4.25ZM11.75 6.5C11.75 6.08579 12.0858 5.75 12.5 5.75C12.9142 5.75 13.25 6.08579 13.25 6.5C13.25 6.91421 12.9142 7.25 12.5 7.25C12.0858 7.25 11.75 6.91421 11.75 6.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.25 10.5C16.25 9.25736 17.2574 8.25 18.5 8.25C19.7426 8.25 20.75 9.25736 20.75 10.5C20.75 11.7426 19.7426 12.75 18.5 12.75C17.2574 12.75 16.25 11.7426 16.25 10.5ZM18.5 9.75C18.0858 9.75 17.75 10.0858 17.75 10.5C17.75 10.9142 18.0858 11.25 18.5 11.25C18.9142 11.25 19.25 10.9142 19.25 10.5C19.25 10.0858 18.9142 9.75 18.5 9.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.5 2.25C18.2574 2.25 17.25 3.25736 17.25 4.5C17.25 5.74264 18.2574 6.75 19.5 6.75C20.7426 6.75 21.75 5.74264 21.75 4.5C21.75 3.25736 20.7426 2.25 19.5 2.25ZM18.75 4.5C18.75 4.08579 19.0858 3.75 19.5 3.75C19.9142 3.75 20.25 4.08579 20.25 4.5C20.25 4.91421 19.9142 5.25 19.5 5.25C19.0858 5.25 18.75 4.91421 18.75 4.5Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconChartScatterplot as ReactComponent };
